{
	"page": {
		"title": "Airlines",
		"count_one": "{{n}} airline",
		"count_other": "{{n}} airlines",
		"intro": "The airlines flights are shown with, and their logos. A flight whose airline has no logo shows its two-letter code instead.",
		"add": "Add airline"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} airline",
		"summary_other": "{{from}}–{{to}} of {{total}} airlines",
		"empty": "No airlines"
	},
	"empty": {
		"filteredTitle": "No airlines match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No airlines yet",
		"noneDescription": "Add the airlines people fly with.",
		"clearFilters": "Clear filters"
	},
	"filters": {
		"searchPlaceholder": "IATA, ICAO or name",
		"logo": "Logo",
		"hasLogo": "Has a logo",
		"noLogo": "No logo",
		"status": "Status"
	},
	"table": {
		"logo": "Logo",
		"iata": "IATA",
		"icao": "ICAO",
		"name": "Airline",
		"country": "Country",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"logoUpdated": "Logo updated",
		"noLogo": "No logo",
		"editLabel": "Edit {{name}}"
	},
	"form": {
		"addTitle": "Add airline",
		"addDescription": "An airline flights can be shown with. Add its logo after saving.",
		"save": "Save changes",
		"addSubmit": "Add airline",
		"field": {
			"iata": "IATA code",
			"iataHint": "The two-character code on tickets, e.g. MH. It cannot be changed later.",
			"iataFixed": "Set when the airline was added; it cannot be changed.",
			"icao": "ICAO code",
			"icaoHint": "Three letters, e.g. MAS.",
			"name": "Name",
			"country": "Country",
			"countryHint": "Two-letter country code, e.g. MY.",
			"active": "Active",
			"activeHint": "Inactive airlines are not shown on flights."
		},
		"placeholder": {
			"iata": "MH",
			"icao": "MAS",
			"name": "Malaysia Airlines",
			"country": "MY"
		},
		"error": {
			"required": "Required",
			"iata": "Enter a 2-character IATA code",
			"icao": "Enter a 3-letter ICAO code",
			"country": "Enter a 2-letter country code",
			"nameTooLong": "At most {{max}} characters",
			"invalid": "Invalid value",
			"iataTaken": "An active airline already uses this IATA code"
		}
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add airline",
		"updateFailed": "Couldn't update airline"
	},
	"logo": {
		"title": "Logo",
		"updated": "Updated {{when}}",
		"none": "No logo yet. Flights show the code badge.",
		"rules": "PNG, JPG or WEBP, up to {{mb}} MB. Saved as a PNG.",
		"upload": "Upload logo",
		"replace": "Replace logo",
		"uploading": "Uploading {{pct}}%",
		"remove": "Remove logo",
		"confirmRemove": "Remove the {{code}} logo? Flights will show the code badge instead.",
		"removeConfirm": "Remove",
		"uploaded": "Logo saved.",
		"removed": "Logo removed.",
		"uploadFailed": "Couldn't upload the logo",
		"removeFailed": "Couldn't remove the logo",
		"wrongType": "Use a PNG, JPG or WEBP image.",
		"tooLarge": "The file is too large. The limit is {{mb}} MB."
	}
}
